<div class="container-tablet">
  <div class="mb-3 d-flex">
    <div
      class="col-2 d-flex align-items-center justify-content-center"
      routerLink="home-tablet"
    >
      <i class="bi bi-arrow-left-circle-fill" style="font-size: 32px"></i>
    </div>

    <h1 class="fw-bold col-8 text-center" style="font-size: 44px">
      TUTORIALES
    </h1>
  </div>

  <div class="input-group mb-3">
    <span class="input-group-text" id="basic-addon1"
      ><i class="bi bi-search"></i
    ></span>

    <input
      type="text"
      class="form-control"
      placeholder="Escribe el nombre de un calentamiento o ejercicio"
      aria-label="Username"
      aria-describedby="basic-addon1"
      style="height: 50px; font-size: 20px"
      [(ngModel)]="searchText"
      (ngModelChange)="filterTutorials()"
    />
  </div>

  <div *ngIf="selectedSection" class="d-flex flex-row" style="margin: 16px 0px">
    <div
      class="col-2 d-flex align-items-center justify-content-center"
      (click)="unselectSection()"
    >
      <i class="bi bi-arrow-left-circle-fill" style="font-size: 32px"></i>
    </div>

    <div class="col-8 d-flex align-items-center justify-content-center">
      <span style="font-size: 32px" *ngIf="!showSections">{{
        selectedSection.name
      }}</span>
    </div>

    <div class="col-2 d-flex align-items-center justify-content-center"></div>
  </div>

  <div *ngIf="showSections">
    <div
      class="section-card d-flex justify-content-between"
      (click)="selectSection(section)"
      *ngFor="let section of sections"
    >
      <div class="d-flex flex-column">
        <span class="section-title">{{ section.name }}</span>
        <span class="section-tutorials-count"
          >{{ section.tutorialCount }} contenidos</span
        >
      </div>

      <div class="d-flex justify-content-center align-items-center"></div>
    </div>
  </div>

  <div *ngIf="showSubsections">
    <div
      class="section-card d-flex justify-content-between"
      (click)="selectSubsection(subsection)"
      *ngFor="let subsection of selectedSection!.subsection"
    >
      <div class="d-flex flex-column">
        <span class="section-title">{{ subsection.name }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="!showSections">
    <div
      class="tutorial-card d-flex justify-content-between align-items-center"
      (click)="manageTutorial(tutorial)"
      *ngFor="let tutorial of tutorials"
    >
      <div class="">
        <span class="tutorial-title">{{ tutorial.name }}</span>
        <span class="tutorial-length"></span>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <i
          class="bi bi-play-circle"
          style="font-size: 32px; color: #ffd80a"
        ></i>
      </div>
    </div>
  </div>
</div>

<iframe #downloadFrame style="display: none"></iframe>

<app-video-modal></app-video-modal>
